import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

import { useColumns } from './hooks/useColumns';
import EmptyState from 'components/EmptyState/EmptyState';
import PortalHeader from 'components/PortalHeader/PortalHeader';
import useDistributionManager from 'api/useDistributionManager';
import DataTable from 'components/DataTableComponent/DataTable';

import '../../views/view.scss';

const ITEMS_PER_PAGE = 100;

const PackageExplorerTable = () => {
  const navigate = useNavigate();
  const { getVersions } = useDistributionManager();
  const columns = useColumns();

  const onCreateNewVersion = () => navigate('./form');

  const versions = getVersions.data || [];
  const isLoading = getVersions.isLoading;
  const isEmpty = versions.length === 0;

  return (
    <div className="h-screen">
      <PortalHeader
        title="Package Explorer"
        primaryButtonText="Create Package"
        onPrimaryButtonClick={onCreateNewVersion}
        isCreateButton
      />
      {isLoading ? (
        <CircularProgress className="absolute top-1/2 left-1/2 h-16 w-16" />
      ) : isEmpty ? (
        <EmptyState
          title="Add your first Package"
          description="Packages are a collection of products that can be purchased together."
          buttonText="Create New Package"
          className="mx-auto mt-36"
          onClick={onCreateNewVersion}
        />
      ) : (
        <div className="p-9">
          <div className="border border-base-sidebarBorder rounded-[20px]">
            <DataTable
              data={versions}
              columns={columns}
              showPagination={true}
              rowsPerPage={ITEMS_PER_PAGE}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PackageExplorerTable;
